import type { Dictionary } from '@src/application/dictionary.js';

export class RequestConfig implements RequestInit {
    headers: Dictionary<string> = {};

    mode: RequestMode = 'cors';

    cache: RequestCache = 'no-cache';

    credentials: RequestCredentials = 'omit';

    redirect: RequestRedirect = 'follow';

    referrerPolicy: ReferrerPolicy = 'no-referrer';

    responseType = 'json';

    method: string|undefined;

    body: any = null;

    signal: AbortSignal|null = null;
}
